
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {promptMessage,fetch,baseUrl} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import wx from 'weixin-js-sdk';
import $ from 'jquery';
import axios from 'axios';
export default {
data()
{
return {
canEdit:false,
lookList:{
video1Look:'',
video2Look:'',
dwzmImageLook:'',
spbrSfzImageLook:'',
tysxgsmImageLook:'',
fsyztysImage1Look:'',
fsyztysImage2Look:'',
artTdtysImage1Look:'',
artTdtysImage2Look:'',
},
submitdisabled:true,
status:'',
dataList:{},
confirmshow:false,
disabled:true,
showdialog:false,
dialogSrc:'',
}
},
directives: {
TransferDom
},
methods:{
Imgsuccess (src, ele) {
const span = ele.parentNode.querySelector('span')
ele.parentNode.removeChild(span)
},
Imgerror (src, ele, msg) {
const span = ele.parentNode.querySelector('span');
for(let i in this.lookList){
if(this.lookList[i] == src){
this.lookList[i] ='';
}
};
ele.parentNode.removeChild(ele);

},
submit(boolen){
if(this.canEdit){
this.canEdit =false;
return false;
}else{
if(boolen){
for(let i in this.lookList){
if(this.lookList[i] ==''){
this.$vux.toast.text('还有资料未上传');
$("body ,html").scrollTop($(this.$refs[i]).offset().top-80);
return false;
}
}
}
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.dataList.filePath = '/person/fetcert/'+this.personInfoId;
this.dataList.hosArea = '01';  
fetch('post',urlConfig.savefsAuthorizationLetter,this.dataList).then(response =>{
this.submitdisabled = false;
this.$store.commit('updateLoadingStatus',{isLoading:false});
if(boolen) {
promptMessage('提示', '提交成功！',function () {
window.location.reload();
});
}else{
window.location.reload();
}

}).catch(error =>{
this.submitdisabled = false;
});
}


},
deleImgClick(code){
this.confirmshow = true;
this.confirmCode = code;

}, //删除
onConfirm(){
this.$store.commit('updateLoadingStatus',{isLoading:true})
let code = this.confirmCode;
fetch('post',urlConfig.imgDelete +'?delFile=/person/fetcert/'+this.personInfoId+'/'+this.dataList[code]).then(response =>{
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.dataList[code] = '';
this.lookList[code+'Look'] = '';
this.submit(false);
this.$vux.toast.text('文件已删除');
console.log(this.lookList[code+'Look'],this.lookList)
}).catch(error =>{
this.$store.commit('updateLoadingStatus',{isLoading:false});

console.log(error)
if(error.indexOf('不存在') != -1){
this.dataList[code] = '';
this.lookList[code+'Look'] = '';
this.submit(false);

}else{
promptMessage('提示','资料删除失败，请重新删除！')
}
});


},
uploadChange(e,src,obj){   //src:1 视频，2：img
var _this = this;
/*        this.$store.commit('updateLoadingStatus',{isLoading:true});*/
let files = e.target.files;
var reader = new FileReader();
for(let i =0;i<files.length;i++){
if(src ==1){
console.log((files[i].size/1024)/1024,'尺寸')
if((files[i].size/1024)/1024 > 200){ // 如果大于200M
promptMessage('提示','上传视频过大，无法上传！');
return false;
}
}else{
if((files[i].size/1024)/1024 > 10){ // 如果大于10M
promptMessage('提示','上传图片过大，无法上传！');
return false;
}
}
this.$vux.loading.show({
text: '上传中，请勿进行其他操作！'
})
let event = e;
reader.readAsDataURL(files[i]);
reader.onload=function(e){
var fromUpdate = new FormData();
fromUpdate.append('uploadfile',files[i]);
fromUpdate.append('filepath','person/fetcert/'+ _this.personInfoId);
fromUpdate.append('rename','true');
fetch('post',urlConfig.imgUpdate,fromUpdate).then(response => {
let file = response;
let fileArry = file.filename.split('/');
_this.dataList[obj] = fileArry[fileArry.length-1];
_this.lookList[obj+'Look'] = e.target.result;
_this.$vux.loading.hide();
event.target.value = null;
}).catch(error => {
_this.$vux.loading.hide();
promptMessage('提示','上传失败，请重新上传')
event.target.value = null;
});

}

}

},  //上传图片
diagClick(src){
this.showdialog = true;
this.dialogSrc = src;

}, // 点击图片放大
getUserId(){
fetch('get',urlConfig.GetSfzh +'?openid='+this.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.getData(response.personInfoId);
this.personInfoId = response.personInfoId;
}).catch(error => {

})

},
getData(personInfoId){
fetch('post',urlConfig.getfsAuthorizationLetter + '?personInfoId='+personInfoId).then(response => {
console.log(response,6)
let url = baseUrl+urlConfig.imgLook+'/person/fetcert/'+this.personInfoId+'/';
for(let i in response){
if(response[i] == null){
response[i] = '';
}
if(response[i]){
this.lookList[i+'Look'] = url + response[i] + '?token=' + window.localStorage.getItem('token');
}
}
this.status = response.status;
this.dataList = response;
this.dataList.personInfoId = this.personInfoId;
this.$store.commit('updateLoadingStatus',{isLoading:false})
console.log(this.lookList.video1Look,12345,response.status)
if(response.status == 1){  //审核通过
promptMessage('提示','<p style="text-align: center;color:#1957e8;font-size: 16px;margin-bottom: 10px;">审核通过</p><div style="text-align: justify;">1.后台工作人员审核通过后持视频及材料至医务部线下签字盖章；<br/>2.线下签字时请携带双方结婚证和身份证。</div>')

}else if(response.status == 2){   //审核不通过
promptMessage('提示','<p style="text-align: center;color:#E64340;font-size: 16px;margin-bottom: 10px;">审核不通过</p><div style="text-align: justify;">1.请于复苏移植前5天提交相关视频及材料；时间<5天请直接联系您的主管护士。<br/>2.后台工作人员审核通过后持视频及材料至医务部线下签字盖章；<br/>3.线下签字时请携带双方结婚证和身份证。</div>')

}else{
this.submitdisabled = false;
let lookListLength= 0;
let lookListTX = 0;
for(let i in this.lookList){
lookListLength++;
if(this.lookList[i]){
lookListTX++;
}
}
if(lookListLength == lookListTX){
this.canEdit =true;
promptMessage('提示','<p style="text-align: center;color:#1957e8;font-size: 16px;margin-bottom: 10px;">已提交,待审核</p><div style="text-align: justify;">1.后台工作人员审核通过后持视频及材料至医务部线下签字盖章；<br/>2.线下签字时请携带双方结婚证和身份证。</div>')
}else{
promptMessage('提示','<div style="text-align: justify;">1.请于复苏移植前5天提交相关视频及材料；时间<5天请直接联系您的主管护士。<br/>2.后台工作人员审核通过后持视频及材料至医务部线下签字盖章；<br/>3.线下签字时请携带双方结婚证和身份证。</div>')
}
}

}).catch(error => {

})
},
imageLoad(key) {

console.log(key)
var ImgObj = new Image();
ImgObj.src = this.lookList[key];
console.log(this.lookList[key],322)
if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
} else {
console.log('图片不存在')
}
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
},
getopenid(code){
let cutton = location.href.split('?')[0];
axios.get(urlConfig.getweixinOpenid + code+'&hosCode='+this.hosCode).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
console.log(response.data.openid,6666)
this.openid = response.data.openid;
getken(this.getUserId);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery;
}
}else{
console.log('获取openid失败')
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery;
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},
},
components: {
Flexbox, FlexboxItem,XHeader,XImg,Confirm,InlineLoading , XDialog,XButton
},
mounted(){

let _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.hosCode ='420100000002';
/*     getken(this.getUserId);*/
axios.get(urlConfig.getsigninfo + encodeURIComponent(window.location.href)
+'&hosCode=' + this.hosCode
).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
console.log(location.href)
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
_this.getopenid(_this.$route.query.code)

}


wx.config({
debug: false,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
appId: _this.weixindata.appId,
jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems']
});
}).catch(function (error) {
promptMessage('提示' +error)

});

}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/fsAuthorizationLetter.vue